// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.certified-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.certified-section .certified-wrap {
  --logo-box-border-radius: 1rem;
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.certified-section .certified-wrap .subtitle-text {
  color: var(--primaryMain-1000);
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  margin-bottom: 2.5rem;
}
.certified-section .certified-wrap .logo-img-box {
  background-color: var(--white-1000);
  border-radius: var(--logo-box-border-radius);
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.certified-section .certified-wrap .logo-img-box img {
  width: 70%;
  height: 70%;
  object-fit: contain;
  object-position: center;
}
.certified-section .certified-wrap .embla {
  width: 100%;
  filter: drop-shadow(0px 4px 4px var(--black-150));
  -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));
}
.certified-section .certified-wrap .embla .embla__viewport {
  border-radius: var(--logo-box-border-radius);
  overflow: hidden;
}
.certified-section .certified-wrap .embla .embla__viewport .embla__container {
  display: flex;
}
.certified-section .certified-wrap .embla .embla__viewport .embla__container .embla__slide {
  min-width: 0;
  flex: 0 0 14.2857142857%;
  padding: 0 1rem;
}
@media screen and (max-width: 991.98px) {
  .certified-section {
    padding: 2.5rem 0;
  }
  .certified-section .certified-wrap .embla .embla__viewport .embla__container .embla__slide {
    padding: 0 0.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .certified-section {
    padding: 2rem 0;
  }
  .certified-section .certified-wrap {
    --logo-box-border-radius: 0.5rem;
  }
  .certified-section .certified-wrap .subtitle-text {
    font-size: 1.125rem;
    margin-bottom: 1.5rem;
  }
  .certified-section .certified-wrap .embla .embla__viewport .embla__container .embla__slide {
    flex: 0 0 20%;
    padding: 0 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CertifiedSection/CertifiedStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,8BAAA;EACA,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AACN;AAEI;EACE,mCAAA;EACA,4CAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAN;AAEM;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAII;EACE,WAAA;EACA,iDAAA;EACA,yDAAA;AAFN;AAIM;EACE,4CAAA;EACA,gBAAA;AAFR;AAIQ;EACE,aAAA;AAFV;AAIU;EACE,YAAA;EACA,wBAAA;EACA,eAAA;AAFZ;AASE;EAzDF;IA0DI,iBAAA;EANF;EAYU;IACE,iBAAA;EAVZ;AACF;AAiBE;EAzEF;IA0EI,eAAA;EAdF;EAgBE;IACE,gCAAA;EAdJ;EAgBI;IACE,mBAAA;IACA,qBAAA;EAdN;EAoBU;IACE,aAAA;IACA,kBAAA;EAlBZ;AACF","sourcesContent":[".certified-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .certified-wrap {\n    --logo-box-border-radius: 1rem;\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .subtitle-text {\n      color: var(--primaryMain-1000);\n      font-size: 1.75rem;\n      font-weight: 700;\n      line-height: 1.4;\n      text-align: center;\n      margin-bottom: 2.5rem;\n    }\n\n    .logo-img-box {\n      background-color: var(--white-1000);\n      border-radius: var(--logo-box-border-radius);\n      aspect-ratio: 1/1;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: 70%;\n        height: 70%;\n        object-fit: contain;\n        object-position: center;\n      }\n    }\n\n    .embla {\n      width: 100%;\n      filter: drop-shadow(0px 4px 4px var(--black-150));\n      -webkit-filter: drop-shadow(0px 4px 4px var(--black-150));\n\n      .embla__viewport {\n        border-radius: var(--logo-box-border-radius);\n        overflow: hidden;\n\n        .embla__container {\n          display: flex;\n\n          .embla__slide {\n            min-width: 0;\n            flex: 0 0 calc(100% / 7);\n            padding: 0 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .certified-wrap {\n      .embla {\n        .embla__viewport {\n          .embla__container {\n            .embla__slide {\n              padding: 0 0.5rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .certified-wrap {\n      --logo-box-border-radius: 0.5rem;     \n      \n      .subtitle-text {\n        font-size: 1.125rem;\n        margin-bottom: 1.5rem;\n      }\n    \n      .embla {\n        .embla__viewport {\n          .embla__container {\n            .embla__slide {\n              flex: 0 0 calc(100% / 5);\n              padding: 0 0.25rem;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
